export const COLOR_REGEX = /^#[A-Fa-f0-9]{6}$/;
export const PARTIAL_COLOR_REGEX = /^#[A-Fa-f0-9]{0,6}$/;

export function formatToHHMMSSTime(time: any): any {
  if (!time) return time;

  const timeArray = time.split(":");
  const hours = timeArray[0];
  const minutes = timeArray[1];
  const seconds = timeArray[2] || "00";
  return `${hours}:${minutes}:${seconds}`;
}
